import styled from "styled-components";

export const DonorForm = styled.form`
  width: 100%;
  padding-bottom: 16px;
`;
